import React, { useState } from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Table from '../../../../components/material-ui/adaptive/Table';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import Card from '../../../../components/material-ui/adaptive/Card';
import { useTranslation } from 'react-i18next';
import MyTableBoldCell from '../../../../components/material-ui/adaptive/MyTableBoldCell';
import CurrentReferral from './CurrentReferral';
import AnchorsLink from './AnchorsLink';

export default function ListReferral({
  referrals,
  deleteReferralHandler,
  editAnchorHandler,
  onCommentChange,
  getNewLink,
  refLinksInfo
}) {
  const { t } = useTranslation();

  const [selectRow, setSelectRow] = useState(referrals?.[0]?.id);
  const [exampleLink, setExampleLink] = useState('https://domain.tid/?start_r=ref_code');
  const [selectGame, setSelectGame] = useState(null);
  const [selectMode, setSelectMode] = useState(null);

  const onAnchorClick = (anchor) => {
    editAnchorHandler(selectRow, anchor);
    setExampleLink((prev) => prev + getNewLink(prev, anchor));
  };

  const openGameClick = ({ gameId, mode }) => {
    console.log(' gameId, mode', gameId, mode);
    setSelectGame(gameId);
    setSelectMode(mode);
  };

  return (
    <Box gap={2}>
      <ShowContainer condition={referrals.length}>
        <Card>
          <TableContainer sx={{ minWidth: { sm: '350px' } }}>
            <Table>
              <TableHead>
                <TableRow>
                  <MyTableBoldCell>{t('Referral links')}</MyTableBoldCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {referrals?.map((link) => (
                  <CurrentReferral
                    link={link}
                    selectRow={selectRow}
                    setSelectRow={setSelectRow}
                    refLinksInfo={refLinksInfo}
                    onCommentChange={onCommentChange}
                    deleteReferralHandler={deleteReferralHandler}
                    selectGame={selectGame}
                    selectMode={selectMode}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </ShowContainer>

      <AnchorsLink
        exampleLink={exampleLink}
        onAnchorClick={onAnchorClick}
        isOpenGame
        openGameClick={openGameClick}
      />
    </Box>
  );
}
